// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TCSInsuranceType;
(function (TCSInsuranceType) {
    TCSInsuranceType[TCSInsuranceType["Pharmacy"] = 1] = "Pharmacy";
    TCSInsuranceType[TCSInsuranceType["Medical"] = 2] = "Medical";
    TCSInsuranceType[TCSInsuranceType["Both"] = 3] = "Both";
})(TCSInsuranceType || (TCSInsuranceType = {}));
//# sourceMappingURL=tCSInsuranceType.js.map